import { render } from "./ValidatorManagement.vue?vue&type=template&id=4dc4236a&scoped=true"
import script from "./ValidatorManagement.vue?vue&type=script&lang=js"
export * from "./ValidatorManagement.vue?vue&type=script&lang=js"

import "./ValidatorManagement.vue?vue&type=style&index=0&id=4dc4236a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc4236a"]])

export default __exports__